export default __webpack_public_path__ + "static/media/Group-146TataNeu.15946891.png";